export const BKJ_J360_VERSION: string = '0.0.2';
